import { ItemCombobox } from '@models-global/model-combobox-item';
import { Values } from '@utils-global/type-values';

export const ENUM_ROLES = {
  ADMIN: 'admin',
  MFG_ADMIN: 'mfg:admin',
  MFG_STAFF: 'mfg:staff',
  MFG_EXECUTIVE: 'mfg:executive',
  RXP_ADMIN: 'rxp:admin',
  RXP_STAFF: 'rxp:staff',
  RXP_EXECUTIVE: 'rxp:executive',
  CUSTOMER_ADMIN: 'customer:admin',
  CUSTOMER_STAFF: 'customer:staff',
  CUSTOMER_EXECUTIVE: 'customer:executive',
  CUSTOMER_REPORTER: 'customer:reporter',
  CE_ADMIN: 'ce:admin',
  CE_STAFF: 'ce:staff',
  TPA_ADMIN: 'tpa:admin',
  TPA_STAFF: 'tpa:staff',
  PHARMACY_ADMIN: 'pharmacy:admin'
} as const;

export const RXP_ROLES: ReadonlyArray<Values<typeof ENUM_ROLES>> =
  Object.values(ENUM_ROLES).filter((role) => role.startsWith('rxp:'));
export const CUSTOMER_ROLES: ReadonlyArray<Values<typeof ENUM_ROLES>> =
  Object.values(ENUM_ROLES).filter((role) => role.startsWith('customer:'));
export const MFG_ROLES: ReadonlyArray<Values<typeof ENUM_ROLES>> =
  Object.values(ENUM_ROLES).filter((role) => role.startsWith('mfg:'));
export const CE_ROLES: ReadonlyArray<Values<typeof ENUM_ROLES>> = Object.values(
  ENUM_ROLES
).filter((role) => role.startsWith('ce:'));
export const TPA_ROLES: ReadonlyArray<Values<typeof ENUM_ROLES>> =
  Object.values(ENUM_ROLES).filter((role) => role.startsWith('tpa:'));
export const PHARMACY_ROLES: ReadonlyArray<Values<typeof ENUM_ROLES>> =
  Object.values(ENUM_ROLES).filter((role) => role.startsWith('pharmacy:'));

export const ARRAY_ROLES: ReadonlyArray<ItemCombobox> = [
  { value: ENUM_ROLES.ADMIN, text: 'Admin' },
  { value: ENUM_ROLES.MFG_ADMIN, text: 'MFG Admin' },
  { value: ENUM_ROLES.MFG_STAFF, text: 'MFG Staff' },
  { value: ENUM_ROLES.MFG_EXECUTIVE, text: 'MFG Executive' },
  { value: ENUM_ROLES.RXP_ADMIN, text: 'RXP Admin' },
  { value: ENUM_ROLES.RXP_STAFF, text: 'RXP Staff' },
  { value: ENUM_ROLES.RXP_EXECUTIVE, text: 'RXP Executive' },
  { value: ENUM_ROLES.CUSTOMER_ADMIN, text: 'Customer Admin' },
  { value: ENUM_ROLES.CUSTOMER_STAFF, text: 'Customer Staff' },
  { value: ENUM_ROLES.CUSTOMER_EXECUTIVE, text: 'Customer Executive' },
  { value: ENUM_ROLES.CUSTOMER_REPORTER, text: 'Customer Reporter' },
  { value: ENUM_ROLES.CE_ADMIN, text: 'CE Admin' },
  { value: ENUM_ROLES.CE_STAFF, text: 'CE Staff' },
  { value: ENUM_ROLES.TPA_ADMIN, text: 'TPA Admin' },
  { value: ENUM_ROLES.TPA_STAFF, text: 'TPA Staff' },
  { value: ENUM_ROLES.PHARMACY_ADMIN, text: 'Pharmacy Admin' }
];

export const ARRAY_ROLES_ALL = [
  ENUM_ROLES.ADMIN,
  ENUM_ROLES.MFG_ADMIN,
  ENUM_ROLES.MFG_STAFF,
  ENUM_ROLES.MFG_EXECUTIVE,
  ENUM_ROLES.RXP_ADMIN,
  ENUM_ROLES.RXP_STAFF,
  ENUM_ROLES.RXP_EXECUTIVE,
  ENUM_ROLES.CUSTOMER_ADMIN,
  ENUM_ROLES.CUSTOMER_STAFF,
  ENUM_ROLES.CUSTOMER_EXECUTIVE,
  ENUM_ROLES.CUSTOMER_REPORTER,
  ENUM_ROLES.CE_ADMIN,
  ENUM_ROLES.CE_STAFF,
  ENUM_ROLES.TPA_ADMIN,
  ENUM_ROLES.TPA_STAFF,
  ENUM_ROLES.PHARMACY_ADMIN
];
